import { render, staticRenderFns } from "./DataCollection.vue?vue&type=template&id=edc0b18c&scoped=true"
import script from "./DataCollection.vue?vue&type=script&lang=js"
export * from "./DataCollection.vue?vue&type=script&lang=js"
import style0 from "./DataCollection.vue?vue&type=style&index=0&id=edc0b18c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc0b18c",
  null
  
)

export default component.exports